<template>
  <div class="my-register-page mb-5">
    <div class="my-container">
      <b-row class="mb-2 mt-3 pt-3">
        <b-col>
          <h1>{{ $t("DishonestRequest") }}</h1>
        </b-col>
      </b-row>

      <b-table-simple bordered>
        <b-thead class="text-center">
          <b-tr variant="primary">
            <b-th style="vertical-align: middle; width: 60px">T/r</b-th>
            <b-th style="vertical-align: middle">{{ $t("FIO") }}</b-th>
            <b-th style="vertical-align: middle">
              {{ $t("organization") }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, index) in Items" :key="index">
            <b-td class="text-center" style="vertical-align: middle">
              {{ (filter.page - 1) * filter.pageSize + index + 1 }}
            </b-td>
            <b-td class="text-nowrap" style="vertical-align: middle">
              {{ item.employeeFullName }}
            </b-td>
            <b-td>{{ item.organization }}</b-td>
          </b-tr>
          <b-tr v-if="!Items || Items.length === 0">
            <b-td colspan="3" class="text-center text-muted">
              {{ $t("NoItems") }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <b-pagination
        v-model="filter.page"
        :total-rows="filter.totalRows"
        :per-page="filter.pageSize"
        first-number
        last-number
        @input="Refresh"
        class="mb-0 mt-1 mt-sm-0"
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <b-icon icon="chevron-double-left" size="18" />
        </template>
        <template #next-text>
          <b-icon icon="chevron-double-right" size="18" />
        </template>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import DishonestRequestService from "@/services/dishonestrequest.service";
import {
  BRow,
  BCol,
  BButton,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BPagination,
} from "bootstrap-vue";
export default {
  data() {
    return {
      Items: [],
      filter: {
        page: 1,
        pageSize: 20,
        totalRows: 0,
      },
    };
  },
  components: {
    BRow,
    BCol,
    BButton,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BTableSimple,
    BPagination,
  },
  created() {
    this.Refresh();
  },
  methods: {
    Refresh() {
      DishonestRequestService.GetList(this.filter)
        .then((res) => {
          this.Items = res.data.rows;
          this.filter.totalRows = res.data.total;
        })
        .catch((error) => {
          this.$message(error.response.data);
        });
    },
  },
};
</script>

<style></style>
